export default __webpack_public_path__ + "static/media/congrats_light.12216877.png";